import React, { useState } from "react";
import Svg, { Path, Circle } from "react-native-svg";

function SvgComponent(props) {
  const { active } = props;
  const activeIndicator = props.indicator;

  if (active) {
    return (
      <Svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        {activeIndicator == true ? (
          <Circle cx="87%" cy="20%" r="3" fill="red" />
        ) : (
          <Circle cx="87%" cy="20%" r="3" fill="white" />
        )}
        <Path
          d="M11.714 22.758c-2.006-.144-3.233-1.16-3.294-1.213a.822.822 0 01-.097-1.145.82.82 0 011.145-.096c.061.053 1.461 1.162 3.652.767a.807.807 0 01.945.653.807.807 0 01-.654.945 7.259 7.259 0 01-1.697.09zM19.407 10.559c1.422 1.421 1.686 2.992 1.697 3.072a.822.822 0 01-.676.93.82.82 0 01-.93-.677c-.01-.08-.343-1.835-2.258-2.97a.807.807 0 01-.287-1.112.807.807 0 011.112-.287c.539.333.975.677 1.342 1.043zM4.468 10.713c-1.34 1.5-1.515 3.082-1.522 3.163a.823.823 0 00.727.89.82.82 0 00.89-.728c.007-.08.24-1.851 2.088-3.092a.807.807 0 00.224-1.127.807.807 0 00-1.126-.223c-.52.362-.936.73-1.281 1.117z"
          fill="#E40046"
        />
        <Path
          d="M16.349 6.605a4.585 4.585 0 01-4.605 4.604A4.586 4.586 0 017.14 6.605 4.586 4.586 0 0111.744 2a4.585 4.585 0 014.605 4.605zM23 17.45a4.585 4.585 0 01-4.605 4.605 4.585 4.585 0 01-4.604-4.605 4.585 4.585 0 014.604-4.604A4.586 4.586 0 0123 17.45zm-12.79.307a4.586 4.586 0 01-4.605 4.605A4.586 4.586 0 011 17.758a4.585 4.585 0 014.605-4.604 4.585 4.585 0 014.604 4.604z"
          fill="#E40046"
        />
      </Svg>
    );
  } else {
    return (
      <Svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        {activeIndicator === true ? (
          <Circle cx="87%" cy="20%" r="3" fill="red" />
        ) : (
          <Circle cx="87%" cy="20%" r="3" fill="white" />
        )}
        <Path
          d="M11.714 22.758c-2.006-.144-3.233-1.16-3.294-1.213a.822.822 0 01-.097-1.145.82.82 0 011.145-.096c.061.053 1.461 1.162 3.652.767a.807.807 0 01.945.653.807.807 0 01-.654.945 7.259 7.259 0 01-1.697.09zM19.407 10.559c1.422 1.421 1.686 2.992 1.697 3.072a.822.822 0 01-.676.93.82.82 0 01-.93-.677c-.01-.08-.343-1.835-2.258-2.97a.807.807 0 01-.287-1.112.807.807 0 011.112-.287c.539.333.975.677 1.342 1.043zM4.468 10.713c-1.34 1.5-1.515 3.082-1.522 3.163a.823.823 0 00.727.89.82.82 0 00.89-.728c.007-.08.24-1.851 2.088-3.092a.807.807 0 00.224-1.127.807.807 0 00-1.126-.223c-.52.362-.936.73-1.281 1.117z"
          fill="#777"
        />
        <Path
          d="M16.349 6.605a4.585 4.585 0 01-4.605 4.604A4.586 4.586 0 017.14 6.605 4.586 4.586 0 0111.744 2a4.585 4.585 0 014.605 4.605zM23 17.45a4.585 4.585 0 01-4.605 4.605 4.585 4.585 0 01-4.604-4.605 4.585 4.585 0 014.604-4.604A4.586 4.586 0 0123 17.45zm-12.79.307a4.586 4.586 0 01-4.605 4.605A4.586 4.586 0 011 17.758a4.585 4.585 0 014.605-4.604 4.585 4.585 0 014.604 4.604z"
          fill="#777"
        />
      </Svg>
    );
  }
}

export default SvgComponent;
